export default __webpack_public_path__ + "static/media/Wanderlust2.b3806fe5.png";